import React, { Fragment, ReactElement, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import classNames from 'classnames/bind';
import dynamic from 'next/dynamic';
import { setPosts } from 'redux/actionCreators/blogActions';
import { endpoints } from 'api/endpoints';
import proxyAxios from 'api/proxyAxios';
import RootLayout from 'layouts/RootLayout';
import { usePaginationData } from 'sections/Blog/hooks/usePaginationData';
import styles from 'pages/blog/Blog.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Blog/components/SectionHeader'));
const SectionPosts = dynamic(() => import('sections/Blog/components/SectionPosts'));

interface BlogProps {
  posts: any[];
};

export default function Blog({ posts = [] }: BlogProps) {
  const dispatch = useDispatch<Dispatch>();
  const { setCurrentPage, pagesQuantity, currentPosts } = usePaginationData(posts, 12);

  useEffect(() => {
    dispatch(setPosts(posts));
  }, [posts]);

  return (
    <section className={cn('blog')}>
      <SectionHeader />
      <SectionPosts
        currentPosts={currentPosts}
        setCurrentPage={setCurrentPage}
        pagesQuantity={pagesQuantity}
      />
    </section>
  );
}

export const getServerSideProps = async () => {
  const meta = {
    title: 'Insights on Global Freight & Logistics | DF Alliance',
    description: 'Explore the DFA Blog & understand the freight logistics market. Bring yourself up-to-speed on industry knowledge. Stay informed and grow your network.',
    path: '/blog',
  };

  try {
    const { data: posts } = await proxyAxios(endpoints.blog.previewArticles + '?order=latest');

    const parsedPosts = posts.map((post: any) => ({
      ...post,
      tag: post.tag ? post.tag : null,
      created_at: new Date(post.date).getTime(),
    }));

    return { props: { posts: parsedPosts, ...meta } };
  } catch (e) {
    console.log('endpoints.Blog', e);
  }

  return { props: { posts: [], ...meta } };
};

Blog.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
